import { FieldValue } from 'firebase/firestore';
import uniqid from 'uniqid';
import { Cafe, Order, OrderItem, OrderLog } from '../../apiTypes';
import { createBatch } from '../../utils/api';

type Props = {
  cafeSlug: string;
  order: DbDocument<Order>;
  workerId: string;
  workerName: string;
  cafe: DbDocument<Cafe>;
  newItems: Record<string, OrderItem>;
  oldItems: Record<string, OrderItem>;
};

export const splitOrder = async ({ order, workerId, workerName, cafe, cafeSlug, newItems, oldItems }: Props) => {
  if (workerName && cafe) {
    const newOrderId = uniqid();
    const orderNumber = cafe.lastOrderNumber + 1;
    const batch = createBatch();

    batch.update<Cafe>(`cafes/${cafeSlug}`, { lastOrderNumber: orderNumber });

    const newOrder: Order = {
      workerId: order.workerId,
      workerName: order.workerName,
      tableId: order.tableId,
      tableName: order.tableName,
      clientId: order.clientId || '',
      clientName: order.clientName || '',
      discount: order.discount || 0,
      closed: false,
      paid: null,
      paidTime: 0,
      number: orderNumber,
      created: new Date().getTime(),
      items: newItems,
      status: order.status || null,
      delivery: order.delivery || null,
      selfOrderPointId: order.selfOrderPointId || null,
    };

    batch.set<Order>(`cafes/${cafeSlug}/orders/${newOrderId}`, newOrder);

    batch.set<OrderLog>(`cafes/${cafeSlug}/orders/${newOrderId}/logs/${uniqid()}`, {
      time: Date.now(),
      workerId,
      workerName,
      type: 'split',
      state: {
        workerId: order.workerId,
        workerName: order.workerName,
        tableId: order.tableId,
        tableName: order.tableName,
        clientId: order.clientId || '',
        clientName: order.clientName || '',
        discount: order.discount || 0,
        items: newItems,
        paid: null,
        status: order.status || null,
        delivery: order.delivery || null,
      },
    });

    const updatedOrderLog: OrderLog = {
      time: Date.now(),
      workerId,
      workerName,
      type: 'split',
      state: {
        workerId: order.workerId,
        workerName: order.workerName,
        tableId: order.tableId,
        tableName: order.tableName,
        clientId: order.clientId || '',
        clientName: order.clientName || '',
        discount: order.discount || 0,
        items: oldItems,
        paid: null,
        status: order.status || null,
        delivery: order.delivery || null,
      },
    };

    batch.update<Order>(`cafes/${cafeSlug}/orders/${order.id}`, {
      items: oldItems as unknown as FieldValue,
    });

    batch.set<OrderLog>(`cafes/${cafeSlug}/orders/${order.id}/logs/${uniqid()}`, updatedOrderLog);

    await batch.commit();
  }
};
